import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { retailerFundedMarketingWholesalerAccessControl } from '../access-control/retailerFundedMarketingWholesalerAccess.configuration'

const MarketplaceSegmentationListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "MarketplaceSegmentationListPage" */
      '../pages/segmentation-list/MarketplaceSegmentationListPage'
    )
)
const StorefrontProSegmentationListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontProSegmentationListPage" */
      '../pages/segmentation-list/StorefrontProSegmentationListPage'
    )
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const retailerFundedMarketingPartnerScopedSegmentRouter = (
  <DomainRoute
    route="segment-partner-scoped"
    tool="segments-dashboard-tool"
    accessControl={retailerFundedMarketingWholesalerAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="segment-marketplace-list"
        tool="marketplace-segments-dashboard-tool"
        // @ts-ignore TODO: Fix strict mode violations
        component={MarketplaceSegmentationListPage}
      />
      <DomainRoute
        exact
        route="segment-storefront-pro-list"
        tool="storefront-pro-segments-dashboard-tool"
        // @ts-ignore TODO: Fix strict mode violations
        component={StorefrontProSegmentationListPage}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
